import React from 'react';
import { Link } from 'gatsby';
import { useLenis } from '@studio-freight/react-lenis';

const CustomLink = ({ children, url, classes }) => {
	const lenis = useLenis();

	function handleScrollTo(event) {
		event.preventDefault();
		if (lenis) {
			const targetId = url.split('scrollto:')[1];
			const targetElement = document.querySelector(targetId);
			if (targetElement) {
				lenis.scrollTo(targetElement);
			}
		}
	}

	if (url.includes('scrollto:')) {
		return (
			<div
				href={url.split('scrollto:')[1]}
				className={classes}
				onClick={handleScrollTo}
			>
				{children}
			</div>
		);
	}
	if (url.includes('http')) {
		return (
			<a href={url} className={classes} target='_blank' rel='noreferrer'>
				{children}
			</a>
		);
	}
	if (url.includes('mailto')) {
		return (
			<a href={url} className={classes} target='_blank' rel='noreferrer'>
				{children}
			</a>
		);
	} else {
		return (
			<Link to={url} className={classes} activeClassName='active'>
				{children}
			</Link>
		);
	}
};
export default CustomLink;
